import React from "react";
const LightSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M10.625 12.5C10.4438 12.5 10.275 12.4625 10.15 12.4062C9.70625 12.175 9.39375 11.8562 9.08125 10.9187C8.7625 9.9437 8.1625 9.48745 7.5875 9.0437C7.09375 8.66245 6.58125 8.2687 6.1375 7.46245C5.80625 6.86245 5.625 6.2062 5.625 5.62495C5.625 3.87495 7 2.49995 8.75 2.49995C10.5 2.49995 11.875 3.87495 11.875 5.62495H13.125C13.125 3.1687 11.2063 1.24995 8.75 1.24995C6.29375 1.24995 4.375 3.1687 4.375 5.62495C4.375 6.41245 4.6125 7.2812 5.04375 8.06245C5.6125 9.0937 6.28125 9.61245 6.825 10.0312C7.33125 10.4187 7.69375 10.7 7.89375 11.3125C8.26875 12.45 8.75 13.0875 9.6 13.5312C9.91875 13.675 10.2688 13.75 10.625 13.75C12.0063 13.75 13.125 12.6312 13.125 11.25H11.875C11.875 11.9375 11.3125 12.5 10.625 12.5ZM4.775 1.64995L3.8875 0.762451C2.64375 2.0062 1.875 3.72495 1.875 5.62495C1.875 7.52495 2.64375 9.2437 3.8875 10.4875L4.76875 9.6062C3.75625 8.58745 3.125 7.1812 3.125 5.62495C3.125 4.0687 3.75625 2.66245 4.775 1.64995ZM7.1875 5.62495C7.1875 6.48745 7.8875 7.18745 8.75 7.18745C9.6125 7.18745 10.3125 6.48745 10.3125 5.62495C10.3125 4.76245 9.6125 4.06245 8.75 4.06245C7.8875 4.06245 7.1875 4.76245 7.1875 5.62495Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.875"
          y="0.762451"
          width="13.25"
          height="14.9875"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LightSvg;
